import ExternalPrenotazioni from "../";

const routes = [
    { name: "ExternalPrenotazioniListPage", path: "/externalprenotazioni/prenotazioni", component: ExternalPrenotazioni.ExternalPrenotazioniListPage, meta: { title: "Prenotazioni" } },
    { name: "ExternalePrenotazioniPresaInCaricoListPage", path: "/externalprenotazioni/presaincarico", component: ExternalPrenotazioni.ExternalePrenotazioniPresaInCaricoListPage, meta: { title: "Prenotazioni" } },
    { name: "TeamsystemIntegratorListPage", path: "/teamsystemintegrator", component: ExternalPrenotazioni.TeamsystemIntegratorListPage, meta: { title: "Fatture TeamSystem" } },
];
export default routes;
